import { useContext, useEffect, useState } from 'react';

import { K8sProvider } from '@cast/shared-types';

import { useAgentScriptQuery } from 'hooks/queries/cluster';

import { CastAnywhereSection } from './CastAnywhereSection';

import { ScriptSection } from '../../../../../../_components/new-onboarding';
import { OnboardClusterContext } from '../../../../../OnboardClusterProvider';
import { colorOrToken, Stack, tokens } from '@cast/design-system';

type Props = {
  onHasScriptChanged: (hasScript: boolean) => void;
};

export const AnywhereScriptContent = ({ onHasScriptChanged }: Props) => {
  const { initialAnywhereClusterName } = useContext(OnboardClusterContext);
  const [anywhereClusterName, setAnywhereClusterName] = useState<string>(
    initialAnywhereClusterName || ''
  );

  const { isLoading, script, error, refetch } = useAgentScriptQuery({
    provider: K8sProvider.ANYWHERE,
    anywhere: { clusterName: anywhereClusterName },
  });

  const hasScript = !!script;

  useEffect(() => {
    onHasScriptChanged(hasScript);
  }, [hasScript, onHasScriptChanged]);

  return (
    <Stack>
      <CastAnywhereSection
        onGenerateScript={setAnywhereClusterName}
        wasScriptGenerated={hasScript}
        isScriptGenerating={isLoading}
        initialAnywhereClusterName={initialAnywhereClusterName}
        error={error}
      />
      {anywhereClusterName && (
        <ScriptSection
          script={script}
          isLoading={isLoading}
          refetch={refetch}
          error={error}
          sx={{
            backgroundColor: colorOrToken(
              'grey.100',
              tokens.theme.bg.structural.page
            ),
            mx: -24,
            px: 24,
            py: 20,
            mb: -20,
          }}
        />
      )}
    </Stack>
  );
};
